import React, { useState } from 'react'
import { GoogleAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult } from 'firebase/auth'
import { auth } from '../../config/firebase'

const GoogleAuthTest: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [result, setResult] = useState<any>(null)

  const testGooglePopup = async () => {
    try {
      setLoading(true)
      setError(null)
      
      const provider = new GoogleAuthProvider()
      provider.addScope('email')
      provider.addScope('profile')
      provider.setCustomParameters({
        prompt: 'select_account'
      })
      
      console.log('Attempting Google sign-in with popup...')
      const result = await signInWithPopup(auth, provider)
      
      console.log('Google sign-in successful:', result)
      setResult({
        user: {
          uid: result.user.uid,
          email: result.user.email,
          displayName: result.user.displayName,
          photoURL: result.user.photoURL
        },
        credential: GoogleAuthProvider.credentialFromResult(result)
      })
    } catch (error: any) {
      console.error('Google sign-in error:', error)
      setError(`Error: ${error.code} - ${error.message}`)
    } finally {
      setLoading(false)
    }
  }

  const testGoogleRedirect = async () => {
    try {
      setLoading(true)
      setError(null)
      
      const provider = new GoogleAuthProvider()
      provider.addScope('email')
      provider.addScope('profile')
      
      console.log('Attempting Google sign-in with redirect...')
      await signInWithRedirect(auth, provider)
    } catch (error: any) {
      console.error('Google redirect error:', error)
      setError(`Error: ${error.code} - ${error.message}`)
      setLoading(false)
    }
  }

  const checkRedirectResult = async () => {
    try {
      setLoading(true)
      setError(null)
      
      console.log('Checking redirect result...')
      const result = await getRedirectResult(auth)
      
      if (result) {
        console.log('Redirect result:', result)
        setResult({
          user: {
            uid: result.user.uid,
            email: result.user.email,
            displayName: result.user.displayName,
            photoURL: result.user.photoURL
          },
          credential: GoogleAuthProvider.credentialFromResult(result)
        })
      } else {
        console.log('No redirect result found')
        setError('No redirect result found')
      }
    } catch (error: any) {
      console.error('Redirect result error:', error)
      setError(`Error: ${error.code} - ${error.message}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-bold mb-4">Google Auth Test</h2>
      
      <div className="space-y-4">
        <button
          onClick={testGooglePopup}
          disabled={loading}
          className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white px-4 py-2 rounded-md"
        >
          {loading ? 'Testing...' : 'Test Google Popup'}
        </button>
        
        <button
          onClick={testGoogleRedirect}
          disabled={loading}
          className="w-full bg-green-600 hover:bg-green-700 disabled:opacity-50 text-white px-4 py-2 rounded-md"
        >
          Test Google Redirect
        </button>
        
        <button
          onClick={checkRedirectResult}
          disabled={loading}
          className="w-full bg-purple-600 hover:bg-purple-700 disabled:opacity-50 text-white px-4 py-2 rounded-md"
        >
          Check Redirect Result
        </button>
      </div>

      {error && (
        <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          <h3 className="font-bold">Error:</h3>
          <p className="text-sm">{error}</p>
        </div>
      )}

      {result && (
        <div className="mt-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded">
          <h3 className="font-bold">Success:</h3>
          <pre className="text-xs mt-2 whitespace-pre-wrap">
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}

      <div className="mt-4 p-3 bg-gray-100 rounded text-xs">
        <h3 className="font-bold">Debug Info:</h3>
        <p>Auth Domain: {auth.app.options.authDomain}</p>
        <p>Project ID: {auth.app.options.projectId}</p>
        <p>Current User: {auth.currentUser?.email || 'None'}</p>
      </div>
    </div>
  )
}

export default GoogleAuthTest 